<template>
    <MainContent>
        <template #header>
            <PageTitle 
                title="Formulario para editar una plantilla de Whatsapp" 
                class="pb-3" 
            />
        </template>

        <template #content>
            <FormPlantilla v-if="plantilla" :plantilla="plantilla" :loading="loading" :errors="errors" @terminado="editarPlantilla" />
        </template>
    </MainContent>
</template>

<script>
    import MainContent from "@/components/backend/components/MainContent";
    import PageTitle from "@/components/backend/components/PageTitleComponent";
    import FormPlantilla from "@/components/backend/plantillas-whatsapp/FormPlantilla.vue";

    export default {
        name: "EditarPlantilla",
        data() {
            return {
                loading: false,
                errors: [],
                plantilla: null
            };
        },
        methods: {
            getPlantilla() {
                this.loading = true;

                const data = {
                    filters: {},
                    teatro_id: this.teatro.id,
                    plantilla_id: this.plantilla_id
                }

                this.$store.dispatch(this.config.getVuexAlias('back.plantillas-whatsapp.show'), data).then(res => {
                    const plantilla = res.data.data;

                    this.plantilla = {
                    ...plantilla,
                    components: {
                        header: { text: "" },
                        body: { text: "" },
                        footer: { text: "" },
                        buttons: [],
                        ...plantilla.components
                    }
                    };
                    this.errors = [];
                }).catch(error => {
                    this.$toast.error(error.response?.data?.message);
                    if(error.response?.data?.errors) {
                        this.errors = error.response?.data?.errors;
                    }
                }).finally(() => {
                    this.loading = false;
                });
            },
            editarPlantilla() {
                this.loading = true;

                const data = {
                    filters: {},
                    teatro_id: this.teatro.id,
                    plantilla_id: this.plantilla_id,
                    components: Object.keys(this.plantilla.components).reduce((acc, key) => {
                        const component = this.plantilla.components[key];
                    
                        if (key === 'buttons' && component.length > 0) {
                            acc[key] = component;
                        } else if (component.text && component.text.trim() !== "") {
                            acc[key] = component;
                        }

                        return acc;
                    }, {})
                }

                this.$store.dispatch(this.config.getVuexAlias('back.plantillas-whatsapp.editar'), data).then(res => {
                    this.$toast.success(res.data?.message)
                    this.plantilla = res.data.data;
                }).catch(error => {
                    this.$toast.error(error.response?.data?.message, { duration: 5000 });
                    if(error.response?.data?.errors) {
                        this.errors = error.response?.data?.errors;
                    }
                }).finally(() => {
                    this.loading = false;
                });
            }
        },
        computed: {
            teatro() {
                return this.$store.getters.getTeatro;
            },
            plantilla_id() {
                return parseInt(this.$route.params.plantilla_id);
            }
        },
        created() {
            this.getPlantilla();
        },
        components: {
            MainContent,
            PageTitle,
            FormPlantilla
        }
    };
</script>